import { Option } from "../components/select/Select";
import { resources } from "./resources";

interface Link {
  icon: string;
  title: string;
  url: string;
}

const pageSizeStr = localStorage.getItem("PGP_SAVED_PAGE_SIZE");
const pageSize = pageSizeStr ? Number(pageSizeStr) : 10;

export const initialPaginationData = { pageSize, total: 0, pageNumber: 1 };

export const allLinks: Link[] = [
  {
    icon: resources.icons.INSTITUTIONS,
    title: "Home",
    url: "/"
  },
  {
    icon: resources.icons.CREDIT_CARD,
    title: "Key Generator",
    url: "/key-generator"
  }
];

export const defaultCardSchemeOptions = [
  {
    label: "MasterCard",
    value: "MasterCard"
  },
  {
    label: "Visa",
    value: "Visa"
  },
  {
    label: "Verve",
    value: "Verve"
  }
];

export const imageExtensions: any = {
  tiff: true,
  tif: true,
  bmp: true,
  jpg: true,
  jpeg: true,
  gif: true,
  png: true,
  eps: true
};

export const certificateConfigTypesOptions: Option[] = [
  {
    label: "Certificate (.pfx)",
    value: "certificate(.pfx)"
  },
  {
    label: "Certificate (.pem)",
    value: "certificate(.pem)"
  },
  {
    label: "Private Keystore (.ks)",
    value: "privatekeystore(.ks)"
  }
];
